define.alias("ember-power-select/helpers/ember-power-select-is-equal", "preview-grid/helpers/ember-power-select-is-equal");